import { parse } from "postcss";
import React, { useEffect, useMemo, useState } from "react";
import Coin from "../Coin/Coin";
import { useStateValue } from '../context/StateProvider'
import { actionType } from '../context/reducer'
import { Alert } from '@mui/material';
import Countdown from 'react-countdown';

const faces = ["Happy", "Sad"];

export default function Asd() {

    const [{ count }, dispatch] = useStateValue()
    const [selectedFace, setSelectedFace] = useState("Happy");
    const [coinFlipResult, setCoinFlipResult] = useState('?');
    const [spin, setSpin] = useState(false);
    const [solana, setSolana] = useState(0.05);
    const [countsol, setCountSol] = useState(100)
    const [alert, setAlert] = useState(null)
    useEffect(() => {
        if (selectedFace && coinFlipResult != "?") {
            if (coinFlipResult === selectedFace) {
                setAlert(true)
                setCountSol(countsol + solana)

            } else {
                setAlert(false)
                setCountSol(countsol - solana)

            }
        } else {
            setAlert(null)
        }


    }, [coinFlipResult])


    const flip = () => {

        let index;
        if (Math.random() < 0.5) {
            index = 0;

        } else {
            index = 1;
        }
        setCoinFlipResult(faces[index]);
        setTimeout(() => {
            setCoinFlipResult("?")
        }, 2000);
        setSpin(true)
        setTimeout(() => {
            setSpin(false)
        }, 1000);



    };


    /*   const computerSelectedFace = useMemo(() => {
          const face = faces.find((f) => f !== selectedFace);
          return face;
      }, [selectedFace]); */
    const isWin = useMemo(() => {
        return coinFlipResult === selectedFace;
    }, [coinFlipResult, selectedFace]);

    const showResult = () => {
        if (isWin) {

            return <p>you win</p>;
        }
        return <p>you lost</p>;
    };
    return (
        <div className="flex w-full h-[70vh] px-10 justify-between items-center">
            <div>
                <p className="font-bold title text-gray-800 text-[5rem]">The Face is <br></br> <span className="text-[#ED1E79]">Happy </span>  <br></br>Or <br></br><span className="text-blue-500">Sad </span> ?</p>
            </div>
            <div className="gap-8 h-full items-center justify-center flex flex-col">
                <Coin side={coinFlipResult} flipping={spin} />
                <div  >
                    <p>You selected: <span className={`${selectedFace === 'Happy' ? 'text-[#ED1E79]' : 'text-blue-500'} font-bold`}>{selectedFace}</span></p>
                    <p>Amount selected: <span className="font-semibold">{solana} SOL </span></p>
                    <p>The Face is: <span className={`${coinFlipResult === 'Happy' ? 'text-[#ED1E79]' : 'text-blue-500'} font-bold`}>{coinFlipResult}</span></p>
                    <div className="absolute">
                        {
                            alert == null ? <Alert className='hidden' variant="outlined" severity="info">
                                Bets 2x with Flip!

                            </Alert> : alert == true ? <Alert variant="outlined" severity="success">
                                You win {solana} SOL !
                            </Alert> : <Alert variant="outlined" severity="error">
                                You lose {solana} SOL !
                            </Alert>
                        }

                    </div>
                </div>

            </div>
            <div className="flex gap-10 flex-col items-center justify-center">
                <div className="gap-2 flex flex-col">
                    <div className="flex">
                 
                        <p className='absolute top-8 right-[350px] font-bold text-gray-600 items-center '> {countsol} SOL </p>
                    </div>
                    <div className="gap-2 flex" >
                        <button className={`${solana === 0.05 ? 'border-gray-400 bg-white text-gray-400' : 'border-white bg-gray-300 text-white'}  hover:bg-white hover:text-gray-400  font-bold py-2 px-4 border-2  hover:border-gray rounded w-[120px]`} onClick={() => setSolana(0.05)}>0.05 SOL</button>
                        <button className={`${solana === 0.10 ? 'border-gray-400 bg-white text-gray-400' : 'border-white bg-gray-300 text-white'}  hover:bg-white hover:text-gray-400  font-bold py-2 px-4 border-2  hover:border-gray rounded w-[120px]`} onClick={() => setSolana(0.10)}>0.10 SOL</button>
                        <button className={`${solana === 0.25 ? 'border-gray-400 bg-white text-gray-400' : 'border-white bg-gray-300 text-white'}  hover:bg-white hover:text-gray-400  font-bold py-2 px-4 border-2  hover:border-gray rounded w-[120px]`} onClick={() => setSolana(0.25)}>0.25 SOL</button>

                        {/*                 <button  className={`${solana === '0.05' ? 'border-blue-500 bg-white text-blue-500' : 'border-white bg-blue-500'}  hover:bg-white hover:text-blue-500 text-white font-bold py-2 px-4 border-2  hover:border-gray rounded w-[200px]`} onClick={() => setSelectedFace("Blue")}>Blue</button>
 */}                </div>
                    <div className="gap-2 flex">
                        <button className={`${solana === 0.50 ? 'border-gray-400 bg-white text-gray-400' : 'border-white bg-gray-300 text-white'}  hover:bg-white hover:text-gray-400  font-bold py-2 px-4 border-2  hover:border-gray rounded w-[120px]`} onClick={() => setSolana(0.50)}>0.50 SOL</button>
                        <button className={`${solana === 1 ? 'border-gray-400 bg-white text-gray-400' : 'border-white bg-gray-300 text-white'}  hover:bg-white hover:text-gray-400  font-bold py-2 px-4 border-2  hover:border-gray rounded w-[120px]`} onClick={() => setSolana(1)}>1 SOL</button>
                    </div>
                </div>
                <div className="gap-8 flex">
                    <button className={`${selectedFace === 'Happy' ? 'border-[#ED1E79] bg-white text-[#ED1E79]' : 'border-white bg-[#ED1E79] text-white'}  hover:bg-white hover:text-[#ED1E79]  font-bold py-2 px-4 border-2  hover:border-gray rounded w-[150px]`} onClick={() => setSelectedFace("Happy")}>Happy</button>
                    <button className={`${selectedFace === 'Sad' ? 'border-blue-500 bg-white text-blue-500' : 'border-white bg-blue-500 text-white'}  hover:bg-white hover:text-blue-500  font-bold py-2 px-4 border-2  hover:border-gray rounded w-[150px]`} onClick={() => setSelectedFace("Sad")}>Sad</button>
                </div>
                {/*  <p>you selected: {selectedFace}</p>
                <p>computer selected: {computerSelectedFace}</p> */}
                {
                    coinFlipResult !== "?" ? <button className=' bg-gray-400 text-white font-bold py-2 px-4 rounded-lg w-[300px]'>Playing</button>
                        : <button onClick={flip} className=' bg-yellow-500 text-white font-bold py-2 px-4 rounded-lg w-[300px]'>Flip</button>

                }
                {/*                  {showResult()} 
 */}            </div>


        </div>

    );
}


{/* <div className="p-20 gap-5 flex flex-col justify-center items-center">
            <div>
              <button  value='1' className="bg-gray-300 hover:bg-white hover:text-[#ED1E79] text-white font-bold py-2 px-4 border-b-4  hover:border-gray rounded w-[100px]">
                1 SOL
              </button>
            </div>
            <div className="gap-6 flex">
              <button className="bg-[#ED1E79] hover:bg-white hover:text-[#ED1E79] text-white font-bold py-2 px-4 border-b-4  hover:border-gray rounded w-[100px]">
                Happy
              </button>
              <button className="bg-blue-500 hover:bg-white hover:text-blue-500 text-white font-bold py-2 px-4 border-b-4  hover:border-gray rounded w-[100px]">
                Blue
              </button>

            </div>

            <button onClick={this.handleClick} class="bg-yellow-500 text-white font-bold py-2 px-4 rounded-lg w-[300px]">
              Flip
            </button>
      
          </div> */}